export const DIDOMI_STORAGE_KEYS = ['didomi_token', 'euconsent-v2'];
